<template>
  <section :class="$style.container" data-luko-tracking="BadgeFilter">
    <Wrapper :class="$style.inner">
      <Title :title-params="primary.title" :class="$style.title" />
      <RichText
        :text-params="primary.description"
        :class="$style.description"
      />
      <div :class="$style.badges">
        <Badge
          v-for="badge in badges"
          :id="badge.id"
          :key="badge.id"
          :is-selected="badge.isSelected"
          @select="onSelect"
        >
          {{ badge.text }}
        </Badge>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'

import Badge from './Badge'

export default {
  name: 'BadgeFilter',
  components: {
    Title,
    RichText,
    Badge,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      primary: this.slice.primary,
    }
  },

  methods: {
    onSelect(badge) {
      this.$emit('select', badge)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 128px 0 0;
}
.inner {
  margin: 0 auto;
  padding: 0 24px;
}
.title {
  font-weight: 200;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  @include below(small) {
    font-size: 32px;
    line-height: 48px;
  }
}
.description {
  @include typo-body;
  margin-bottom: 24px;

  color: $gray-700;
  text-align: center;
}
.badges {
  text-align: center;
  @include below(small) {
    display: none;
  }
}
</style>
